export const projectRoutes = [
  {
    id: "1.1",
    routes: ["/orders"],
  },
  {
    id: "1.3",
    routes: ["/future-orders"],
  },
  {
    id: "1.2",
    routes: ["/orders/abandoned-carts"],
  },
  {
    id: "2.1",
    routes: [
      "/products/items",
      "/time-bounded-products",
      "/products/wishlist",
      "/preview-items",
    ],
  },
  {
    id: "2.2",
    routes: ["/products/categories"],
  },
  {
    id: "2.3",
    routes: [
      "/products/setup/option-sets",
      "/products/setup/inner-option-sets",
      "/products/setup/attributes",
      "/products/setup/filters-tags",
      "/products/setup/brands",
      "/products/setup/mods",
    ],
  },
  {
    id: "2.5",
    routes: ["/products/branch-association"],
  },
  {
    id: "2.4",
    routes: ["/photos"],
  },
  {
    id: "4.1",
    routes: ["/campaigns/loyalty"],
  },
  {
    id: "4.2",
    routes: ["/campaigns/coupons", "/campaigns/coupon-report"],
  },
  {
    id: "5.0",
    routes: ["/reservations", "/reservations/expired"],
  },
  {
    id: "6.1",
    routes: ["/custom-reports", "/custom-reports/builder"],
  },
  {
    id: "6.2",
    routes: ["/performance/orders"],
  },
  {
    id: "6.3",
    routes: ["/performance/loyalty"],
  },
  {
    id: "6.4",
    routes: ["/performance/delivery"],
  },
  {
    id: "6.5",
    routes: ["/product-reviews", "/business-reviews"],
  },
  {
    id: "6.6",
    routes: ["/performance/customers"],
  },
  {
    id: "6.7",
    routes: ["/performance/traffic"],
  },
  {
    id: "6.8",
    routes: ["/performance/insights"],
  },
  {
    id: "8.1",
    routes: [
      "/website/banners",
      "/website/ticker",
      "/website/popup",
      "/website/favicon",
    ],
  },
  {
    id: "8.2",
    routes: ["/seo/product", "/seo/category", "/seo/brand", "/seo/page"],
  },
  {
    id: "8.3",
    routes: ["/website/static-pages"],
  },
  {
    id: "8.4",
    routes: ["/website/theme"],
  },
  {
    id: "9.0",
    routes: ["/customers"],
  },
  {
    id: "10.1",
    routes: [
      "/pos-reports/sales-summary",
      "/pos-reports/day-end",
      "/pos-reports/cash-drawer-summary",
      "/pos-reports/house-account-list",
      "/pos-reports/daily-sale",
      "/pos-reports/products",
    ],
  },
  {
    id: "10.2",
    routes: ["/staff-attendance"],
  },
  {
    id: "10.3",
    routes: ["/download-pos"],
  },
  {
    id: "12.1",
    routes: ["/suppliers"],
  },
  {
    id: "12.2",
    routes: ["/stocks"],
  },
  {
    id: "12.3",
    routes: ["/purchase-order"],
  },
  {
    id: "12.4",
    routes: ["/purchases"],
  },
  {
    id: "11.0",
    routes: [
      "/settings",
      "/settings/activity-logs",
      "/settings/business-info",
      "/settings/business-info/profile",
      "/settings/business-info/locations",
      "/settings/product-settings",
      "/settings/order-settings",
      "/settings/order-settings/delivery-options",
      "/settings/order-settings/order-options",
      "/settings/order-settings/delivery-areas",
      "/settings/order-settings/delivery-ranges",
      "/settings/order-settings/payment-types",
      "/settings/delivery-charges",
      "/settings/delivery-charges/map",
      "/settings/communication-settings",
      "/settings/communication-settings/orders",
      "/settings/communication-settings/orders/email",
      "/settings/communication-settings/orders/sms",
      "/settings/communication-settings/reservations",
      "/settings/communication-settings/reservations/sms",
      "/settings/business-hours",
      "/settings/reservation",
      "/settings/reservation/hours",
      "/settings/reservation/details",
      "/settings/users",
      "/settings/integration",
      "/settings/integration/payments",
      "/settings/integration/firebase",
      "/settings/integration/google-analytics",
      "/settings/integration/canadaPost",
      "/settings/integration/TCSExpress",
      "/settings/integration/eShipper",
      "/settings/integration/ShipStation",
      "/settings/integration/Pandago",
      "/settings/integration/DoorDash",
      "/settings/integration/Bykea",
      "/settings/integration/Twillio",
      "/settings/integration/Sms",
    ],
  },
  {
    id: "13.0",
    routes: ["/download-partner-app"],
  },
  {
    id: "14.0",
    routes: ["/billing"],
  },
  {
    id: "15.0",
    routes: ["/subscriptions"],
  },
];

export const projectModules = [
  { value: "1.1", label: "Orders" },
  { value: "1.3", label: "Future Orders" },
  { value: "1.2", label: "Abandoned Carts" },
  { value: "2.1", label: "Product Items" },
  { value: "2.2", label: "Product Categories" },
  { value: "2.3", label: "Product Setup" },
  { value: "2.5", label: "Branch association" },
  { value: "2.4", label: "Photos" },
  { value: "4.1", label: "Loyalty" },
  { value: "4.2", label: "Coupons" },
  { value: "5.0", label: "Reservations" },
  { value: "6.1", label: "Custom Reports" },
  { value: "6.2", label: "Orders Dashboard" },
  { value: "6.3", label: "Loyalty Dashboard" },
  { value: "6.4", label: "Delivery Dashboard" },
  { value: "6.5", label: "Reviews" },
  { value: "6.6", label: "Customers Dashboard" },
  { value: "6.8", label: "Insights" },
  { value: "8.1", label: "Website Display" },
  { value: "8.2", label: "SEO" },
  { value: "8.3", label: "Static Pages" },
  { value: "8.4", label: "Website Theme" },
  { value: "9.0", label: "Customers" },
  { value: "10.1", label: "POS Reports" },
  { value: "10.2", label: "Staff Attendance" },
  { value: "10.3", label: "Download POS" },
  { value: "11.0", label: "Settings" },
  { value: "13.0", label: "Partner App Download" },
  { value: "15.0", label: "Subscriptions" },
];

export const userRoles = [
  { value: "super-admin", label: "Super Admin" },
  { value: "manager", label: "Manager" },
];
